type SetCookieOptions = {
  path?: string;
  domain?: string;
  secure?: boolean;
  maxAge?: number;
  sameSite?: 'Strict' | 'Lax' | 'None';
};

type DeleteCookieOptions = {
  path?: string;
  domain?: string;
};

export function SetCookie(name: string, value: string, options?: SetCookieOptions): void {
  if (typeof document === 'undefined') {
    return;
  }
  const segments: string[] = [`${name}=${encodeURIComponent(value)}`];
  const path = options && options.path ? options.path : '/';
  segments.push(`path=${path}`);
  if (options && options.domain) {
    segments.push(`domain=${options.domain}`);
  }
  if (options && typeof options.maxAge === 'number') {
    segments.push(`max-age=${options.maxAge}`);
  }
  const sameSite = options && options.sameSite ? options.sameSite : 'Lax';
  segments.push(`SameSite=${sameSite}`);
  if (options && options.secure) {
    segments.push('Secure');
  }
  document.cookie = segments.join('; ');
}

export function DeleteCookie(name: string, options?: DeleteCookieOptions): void {
  if (typeof document === 'undefined') {
    return;
  }
  const segments: string[] = [`${name}=`];
  const path = options && options.path ? options.path : '/';
  segments.push(`path=${path}`);
  if (options && options.domain) {
    segments.push(`domain=${options.domain}`);
  }
  segments.push('max-age=0');
  segments.push('SameSite=Lax');
  document.cookie = segments.join('; ');
}
